import { ROOM_TYPE } from "../../../constants/discussion";
import conditionHelper from "../../../helpers/condition";

const ChannelItem = () => import("../ChannelItem/ChannelItem.vue");

export default {
    props: ['conversations', 'selectedRoom', 'name'],
    components: {
        ChannelItem,
    },
    computed: {
        channelPhoto() {
            if (!this.selectedRoom) return '';
            return this.selectedRoom.photo;
        },
        isShowClientChannel() {
            return conditionHelper('rcfchatadvteamclient')
        },
        isShowAdvTeamChannel() {
            return conditionHelper('rcfchatadvteam')
        }
    },
    methods: {
        isChannelActive(data) {
            if (!this.selectedRoom) return false;
            return this.selectedRoom.detail.id === data.id;
        },
        isTeamChannel(channel) {

            return channel.type == ROOM_TYPE.TEAM;
        },
    },
}